import { useGraphWebhook } from '@squareup/dex-feature-hooks-graph';
import { ReferenceHrefBuilders, toUrl } from '@squareup/dex-tech-utils-routing';
import { HeadWrapper } from '@squareup/dex-ui';
import { ReferenceWebhookContent } from '@squareup/dex-ui-reference-webhook';
import { ContentLayoutGrid } from '@squareup/dex-ui-shared-content-layout-grid';
import { useDecision } from '@squareup/dex-ui-shared-feature-detection';
import {
  getNextPublicApiReferenceNameOrDefault,
  getNextPublicSquareDocsURL,
} from '@squareup/dex-utils-environment';
import { toWebhookPathParam } from '@squareup/dex-utils-oas';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React, { ReactNode } from 'react';

import { SquareVersionPage } from '../../../../shared/SquareVersionPage';

const PageContent = () => {
  const { webhook } = useGraphWebhook();
  const params = useParams();

  const { decision } = useDecision('narrow_property_table');
  const narrowViewEnabled = decision.enabled;

  const currentVersion = params?.square_version as string;

  if (!webhook) {
    return null;
  }

  const title = `${
    webhook.name
  } Webhook - ${getNextPublicApiReferenceNameOrDefault()}`;

  return (
    <>
      <HeadWrapper
        description=""
        preconnectUrl={getNextPublicSquareDocsURL()}
        title={title}
        canonicalPath={toUrl(
          ReferenceHrefBuilders.versionWebhooksWebhook({
            square_version: currentVersion,
            webhook: toWebhookPathParam(webhook),
          })
        )}
      />
      <ContentLayoutGrid>
        <ReferenceWebhookContent
          webhook={webhook}
          currentVersion={currentVersion}
          narrowPropertyView={narrowViewEnabled}
        ></ReferenceWebhookContent>
      </ContentLayoutGrid>
    </>
  );
};

class Page extends SquareVersionPage {
  public static override routeHandlerName =
    '[square_version]/webhooks/[webhook]';

  protected override getPageContent(): ReactNode {
    return super.getPageContent({
      children: <PageContent />,
    });
  }
}
export default Page;
